import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { withRouter, Link } from 'react-router-dom';
import { setLocation } from '../../containers/Home/actions';
import { setCurrentUser } from '../../containers/Login/actions';
import CheckoutIcon from './checkout';
import MarkerIcon from '../LocationInput/marker';

const Navbar = styled.nav`
  min-height: 5rem !important;
  z-index: 3;

  @media screen and (max-width: 768px) {
    ${props => props.excluded && `
      background-color: #FFBF00 !important;
      color: #FFFFFF;
    `}
  }
`;

const NavbarBrand = styled.div`
  display: flex;
  justify-content: space-between;

  svg {
    width: 20px;
    height: 20px;
  }
`;

const Location = styled.div`
  display: flex;
  align-items: center;
  margin-left: 0.5em;

  span {
    margin-left: 0.5em;
  }
`;

const Logo = styled.a`
  font-size: 30px !important;
  font-family: 'Muli', sans-serif;
  color: #FFBF00 !important;
  font-weight: 700 !important;
`;

const MobileSignIn = styled.a`
  margin: 0.5em 0.75em auto auto;
`;

class Nav extends Component {
  logout = () => {
    this.props.history.push('/');
    this.props.clearUser();
  }

  onSuggestSelect = (suggest) => {
    if (suggest !== undefined) {
      this.props.setUserLocation({
        lat: suggest.location.lat,
        lng: suggest.location.lng,
        formattedAddress: suggest.label,
        address: suggest.gmaps.name
      });
    }
  }

  getNumberOfItems = (items) => {
    return items.reduce((value, item) => value + item.quantity, 0)
  }

  render() {
    const { items, maps, auth: { user }, history: { push }, location: { pathname }, open } = this.props;
    const metadata = user ? JSON.parse(user.profile) : null;
    const excluded = pathname.includes('/shops');
    return (
      <Navbar
        className='navbar is-fixed-top'
        role='navigation'
        aria-label='main navigation'
        excluded={excluded}
        onClick={excluded ? () => open() : () => {}}
      >
        <div className='container'>
          <NavbarBrand className='navbar-brand'>
            {(!excluded || window.innerWidth > 768) && <Logo className='navbar-item' onClick={() => window.location.href = '/'}>
              cloudchefs
            </Logo>}
            {excluded && <Location className='has-text-weight-semibold mt-1 is-hidden-desktop'>
              <MarkerIcon /> &nbsp; <span>{maps.location ? maps.location.address : 'Enter your delivery address'}</span>
            </Location>}
            {/* eslint-disable-next-line */}
            {!excluded && <MobileSignIn
              role='button'
              className='button is-primary is-hidden-desktop no-hover-change has-text-white'
              aria-label='menu'
              aria-expanded='false'
              data-target='navbar'
              onClick={() => push('/checkout')}
            >
              <CheckoutIcon /> &nbsp; {items.length}
            </MobileSignIn>}
          </NavbarBrand>
          <div id='navbar' className='navbar-menu'>
            <div className='navbar-start'>
              {(maps && maps.location) && <span className='navbar-item'>
                <MarkerIcon /> &nbsp;
                Delivering to &nbsp; <span className='has-text-weight-semibold'>{maps.location.address}</span>
              </span>}
            </div>
            <div className='navbar-end'>
              {(user && new Date().getTime() < user.expiresAt)
                ? <div className='navbar-item has-dropdown is-hoverable'>
                    <a className='navbar-link is-arrowless'>
                      Hi, {metadata.firstName}
                    </a>
                    <div className='navbar-dropdown'>
                      <Link to='/orders' className='navbar-item'>
                        My Orders
                      </Link>
                      <Link to='/edit-account' className='navbar-item'>
                        Edit Account
                      </Link>
                      <Link to='/contact-us' className='navbar-item'>
                        Contact Support
                      </Link>
                      <hr className='navbar-divider' />
                      <a href='javascript:void(0)' onClick={() => this.logout()} className='navbar-item'>
                        Sign out
                      </a>
                    </div>
                  </div>
                : <span className='navbar-item'>
                  <div className='field has-addons'>
                    <p className='control'>
                      <button
                        className='button is-primary'
                        type='button'
                        onClick={() => {
                          push('/register');
                        }}
                      >
                        Register
                      </button>
                    </p>
                    <p className='control'>
                      <button
                        className='button is-primary is-outlined'
                        type='button'
                        onClick={() => {
                          push('/login');
                        }}
                      >
                        Sign In
                      </button>
                    </p>
                  </div>
                </span>
              }
              <div className='navbar-item'>
                <button
                  type='button'
                  open={this.getNumberOfItems(items) > 0}
                  onClick={() => push('/checkout')}
                  className={this.getNumberOfItems(items) > 0 ? 'button is-primary ' : 'button is-primary is-outlined'}
                >
                  <CheckoutIcon size='fa-w-14' /> &nbsp; {this.getNumberOfItems(items)} &nbsp; Checkout
                </button>
              </div>
            </div>
          </div>
        </div>
      </Navbar>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    items: state.basket.menuItems,
    maps: state.location,
    auth: state.auth,
  };
};

const mapDispatchToProps = dispatch => ({
  setUserLocation: value => dispatch(setLocation(value)),
  clearUser: () => dispatch(setCurrentUser(null)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Nav));
